import styled from 'styled-components';

export const Container = styled.button`
  margin-top: 12px;
  padding: 20px;

  color: ${({ textColor }) => textColor};
  font-weight: 700;
`;
